import { FlexDiv, HorizontalFlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const ServicesContainer = styled(HorizontalFlexDiv)`
    padding: 0px 8px 8px 8px;
    gap: 20px;
    flex-wrap: wrap;
    align-items: start;
`
export const NoCategorySelectedContainer = styled(FlexDiv)`
    justify-content: center;
    align-items: center;
    flex: 1;
`